import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { EmsHocaFeaturesProperties, Feature, FeatureNames } from '@vi-iot/client';

import {
  HemsAdvancedAnalysisStatus,
  InstallationDetailsStore,
  InstallationFeaturesStore,
} from '@store';

import { UIService } from '../../../shared/services';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-hems',
  templateUrl: './hems.component.html',
  styleUrls: ['./hems.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HemsComponent implements OnInit {
  readonly HemsAdvancedAnalysisStatus = HemsAdvancedAnalysisStatus;

  @Input() boilerSerial: string;
  hocaFeatures$: Observable<Feature<EmsHocaFeaturesProperties, never>>;

  constructor(
    public installationDetailsStore: InstallationDetailsStore,
    private installationFeaturesStore: InstallationFeaturesStore,
    private uiService: UIService
  ) {}

  ngOnInit(): void {
    this.hocaFeatures$ = this.installationFeaturesStore.selectInstallationHemsFeature(
      FeatureNames.hocaFeatures
    );
  }

  openSettingsOverlay(): void {
    this.uiService.openActiveOverlay(FeaturesDetailsOverlayTypeEnum.HemsSettings);
  }
}
